import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {useCurrentCompanyQuery} from "../apis/companiesApi";
import {useUserProfileQuery} from "../apis/authenticationApi";

export const usePageTracking = () => {
    const location = useLocation();
    const {data: currentCompany} = useCurrentCompanyQuery();
    const {data: userProfile} = useUserProfileQuery();

    useEffect(() => {
        window.gtag("event", "page_view", {
            page_path: location.pathname + location.search + location.hash,
            page_search: location.search,
            page_hash: location.hash,
            company: currentCompany?.name,
            user_name: userProfile?.firstName && userProfile?.lastName && `${userProfile?.firstName} ${userProfile?.lastName}`,
            user_email: userProfile?.email
        });
    }, [location, currentCompany, userProfile]);
};
